$ = require 'jquery'
View = require 'view'
orgPrefsVis = require 'views/templates/org_prefs_vis'

module.exports = class OrganizationRestrictBoardVisibilityView extends View
  viewTitleKey: 'board creation restrictions'

  initialize: ->
    @listenTo @model, 'change:prefs', @frameDebounce @render

  events:
    'click a': 'changeRestriction'

  render: ->
    org = @model.toJSON(prefs: true)
    enterprise = @model.getEnterprise()?.toJSON(displayName: true)

    @$el.html(orgPrefsVis(org, enterprise))

    @

  changeRestriction: (e) ->
    $target = $(e.target)

    if $target.hasClass('disabled')
      return

    prefName = "boardVisibilityRestrict/" + $target.closest('ul').attr('data-vis')
    setting = $target.attr('data-restriction')

    @model.setPref(prefName, setting)



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-restrict-board-visibility-view.coffee